import type { Dict } from '../utils'

import { createContext } from '../utils'

const [MenuProvider, useMenuContext] = createContext<Dict>({ isOptional: true })

export { MenuProvider, useMenuContext }
